export default {
	methods: {
		emitUpdatedDate: function (mode, filter_object, updated_field, updated_date) {

			if (mode == 'range') {
				if(updated_date){
					this[filter_object][updated_field][0] = updated_date.date.start_date;
					this[filter_object][updated_field][1] = updated_date.date.end_date;
				}else{
					// clean date
					this[filter_object][updated_field][0] = '';
					this[filter_object][updated_field][1] = '';
				}
			} else {
				if (typeof filter_object == 'object') {
					if (updated_date) {
						filter_object[updated_field] = updated_date.date;
					} else {
						filter_object[updated_field] = null
					}
				} else {
					if (updated_date) {
						this[filter_object][updated_field] = updated_date.date
					} else {
						this[filter_object][updated_field] = null
					}
				}
			}
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/inputs/DatePickerMixin.js